<template>
  <div
    class="user-thumbnail"
  >
    <a href="/painel/gerenciar/perfil">
      <img
        class="user-thumbnail__image"
        :src="thumbnailSrc"
        alt="Foto de perfil"
      >
    </a>

    <button
      class="button-no-style user-thumbnail__stamp-button"
      @click="handleClick()"
    >
      <verification-stamp
        v-if='isMobileV2'
        @userVerificationStatus='userVerificationStatus = $event'
      ></verification-stamp>

      <verification-stamp-popover
        v-else
      ></verification-stamp-popover>

    </button>

    <verification-stamp-modal
      ref='VerificationStampModal'
      :userVerificationStatus='userVerificationStatus'
    ></verification-stamp-modal>
  </div>
</template>

<script>
import isMobile from 'commons/js/mixins/isMobile';
import VerificationStamp from "commons/js/components/atoms/VerificationStamp";
import VerificationStampModal from 'commons/js/components/atoms/VerificationStampModal';
import VerificationStampPopover from 'commons/js/components/atoms/VerificationStampPopover';

export default {
  components: {
    VerificationStamp,
    VerificationStampModal,
    VerificationStampPopover
  },

  mixins: [isMobile],

  props: {
    userThumbnail: {
      type: String,
      default: false
    }
  },

  data() {
    return {
      userVerificationStatus: '',
    }
  },

  computed: {
    thumbnailSrc() {
      return this.userThumbnail || '/images/_util/persona.svg';
    }
  },

  methods: {
    handleClick() {
      if(this.isMobileV2) {
        this.$refs.VerificationStampModal.open();
      }
    }
  }
}
</script>

<style lang="stylus" scoped>
.user-thumbnail
  position relative
  vertical-align middle
  height 32px
  min-width 72px
  width fit-content
  display flex
  align-items center
  justify-content space-between

  @media screen and (min-width 940px)
    display inline-block
    height 46px
    width 46px
    min-width auto

  &__image
    border-radius 50%
    border 1px solid #c7c7c7
    width 100%
    position absolute
    top 0
    left 0
    font-size 6px
    width 32px
    height 32px

    @media screen and (min-width 940px)
      width 46px
      height 46px

  &__stamp-button
    width fit-content
    height fit-content
    cursor help
    display flex
    align-items center
    justify-content center
    padding 0
    margin-left 20px

    @media screen and (min-width 940px)
      position absolute
      bottom 0
      left -12px
      margin-left 0
</style>
